module.exports = __webpack_public_path__ + "static/hypercast-thumb-87da23c4aaa7695edf99c54e91936bd0.png";